const currentDate = new Date();

const day = currentDate.getDate();
const month = currentDate.toLocaleString('default', { month: 'short' });
const year = currentDate.getFullYear();

const dateToday = `${day}-${month}-${year}`;

export {dateToday};
